import script from "./SubscriptionWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionWidget.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionWidget.vue?vue&type=style&index=0&id=40531b7e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40531b7e"]])

export default __exports__